/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
/**
 * A utility class that provides methods for managing popups.
 *
 * [[include:absdk/commons/ui/popup/AbPopupManager.md]]
 */
export class AbPopupManager {
  /**
   * Show a popup above all other layers.
   *
   * @param {React.ReactElement<any>} popup The popup to be shown to the user.
   * @returns {AbPopupHandle} The handle of the new popup.
   */
  static show(popup) {
    // Previous behavior was to NOT default the ownerPopupRegistry, so keeping it.
    // Andy: will eventually support auto-defaulting after internal implementation is battle tested)
    return PopupUtils.showPopupExplicitly(popup, {
      ownerPopupRegistry: null
    });
  }
}
//# sourceMappingURL=AbPopupManager.js.map
